import { Validators, } from '@angular/forms';
import isArray from 'lodash-es/isArray';
export function maxLength(max, options) {
    var validator = Validators.maxLength(max);
    return function (c) {
        var _a;
        var isNested = options && !!options.property;
        var entries = isArray(c.value) ? c.value : [c.value];
        var result = null;
        entries.forEach(function (entry) {
            var value = isNested && entry != null ?
                entry[options.property] :
                entry;
            result = validator({
                value: value,
            });
        });
        return result != null && isNested ? (_a = {},
            _a[options.property + ".maxlength"] = result.maxlength,
            _a) :
            result;
    };
}
